import { Badge } from '@lms/ui';

const STATUS_VARIANT: Record<string, 'success' | 'warning' | 'danger' | 'primary' | 'default'> = {
  active: 'success',
  pending: 'warning',
  suspended: 'danger',
  completed: 'primary',
  cancelled: 'default',
};

const STATUS_LABELS: Record<string, string> = {
  active: 'Activa',
  pending: 'Pendiente',
  suspended: 'Suspendida',
  completed: 'Completada',
  cancelled: 'Cancelada',
};

export function EnrollmentStatusBadge({ status }: { status?: string }) {
  const key = status ?? 'active';
  return <Badge variant={STATUS_VARIANT[key] ?? 'default'}>{STATUS_LABELS[key] ?? key}</Badge>;
}
